import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MSI_CONTENT_MODAL_DATA, MsiContentModalRef, ContentModalModule } from '@msi/cobalt';
import { NewFeatureModalService } from '../../services/new-feature-modal/new-feature-modal.service';
import { ReleaseNote } from '../../interfaces/modal.interface';
import { filter, take, takeUntil } from 'rxjs/operators';
import { merge, Subject, timer } from 'rxjs';
import { IconModule } from '@msi/cobalt/icon';

@Component({
	selector: 'app-new-feature-modal',
	templateUrl: './new-feature-modal.component.html',
	styleUrls: ['./new-feature-modal.component.scss'],
	standalone: true,
	imports: [ContentModalModule, IconModule],
})
export class NewFeatureModalComponent implements OnInit, OnDestroy {
	public releaseNotes: ReleaseNote[] = [];

	private destroy: Subject<void> = new Subject();

	constructor(
		private newFeatureModalService: NewFeatureModalService,
		public modalRef: MsiContentModalRef,
		@Inject(MSI_CONTENT_MODAL_DATA) public data: { selectedMediaIndex: number }
	) {}

	ngOnInit() {
		this.newFeatureModalService.releaseNotes$.pipe(takeUntil(this.destroy)).subscribe(data => {
			this.releaseNotes = data;
		});
	}

	ngOnDestroy(): void {
		this.destroy.next();
		this.destroy.complete();
	}

	modalIndexChanged(idx: number) {
		// When user views the latest release notes, update localStorage
		if (idx === 0 && this.releaseNotes[idx]?.releaseTitle) {
			localStorage.setItem('latestReleaseNotesViewed', this.releaseNotes[idx].releaseTitle);
		}
	}

	refreshModalContent(i: number) {
		// Don't refresh if already refreshing or if page is already loaded
		if (!!this.releaseNotes[i]?.fileContents || document.getElementsByClassName('refreshing')[0]) {
			return;
		}
		const itemElement = document.getElementsByClassName('msi-content-modal-button-refresh')[0];
		itemElement?.classList.add('refreshing');
		merge(this.newFeatureModalService.releaseNotes$, timer(15000))
			.pipe(
				filter(release => (typeof release === 'number' ? true : !!release[i].fileContents)),
				takeUntil(this.destroy),
				take(1)
			)
			.subscribe(() => {
				itemElement?.classList.remove('refreshing');
			});
		this.newFeatureModalService.loadReleaseNote(i);
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
